import { render, staticRenderFns } from "./ScopedColorTheme.vue?vue&type=template&id=03ebb128&"
import script from "./ScopedColorTheme.vue?vue&type=script&lang=js&"
export * from "./ScopedColorTheme.vue?vue&type=script&lang=js&"
import style0 from "./ScopedColorTheme.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports